import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-pos-unlock-order-observations',
  templateUrl: './pos-unlock-order-observations.component.html',
  styleUrls: ['./pos-unlock-order-observations.component.sass']
})
export class PosUnlockOrderObservationsComponent implements OnInit {
  @Output() observationsEmitter = new EventEmitter<string>();

  constructor(public bsModalRef: BsModalRef, private formBuilder: FormBuilder) { }

  @Input() observations: string = "";
  @Input() isDisabled: boolean = false;
  @Input() title: string = "Observaciones"
  observationForm: FormGroup = this.formBuilder.group(
    {
      observationText: new FormControl("", [Validators.required, Validators.max(800)]),
    }
  );

  ngOnInit(): void {
  }

  load() {
    this.observationForm.get("observationText")?.setValue(this.observations);
    if (this.isDisabled) {
      this.observationForm.disable();
    }
  }

  confirm() {
    this.observationsEmitter.emit(this.observationForm.get("observationText")?.value);
    this.observationsEmitter.complete();
    this.bsModalRef.hide();
  }

  cancel() {
    this.observationsEmitter.emit(undefined);
    this.observationsEmitter.complete();
    this.bsModalRef.hide();
  }
}
